import React from 'react'
import styles from './styles.module.css'

const GiftPreference = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.giftIcon}>🎁</div>
        <h2 className={styles.mainTitle}>Пожелания по подаркам</h2>
        <div className={styles.divider}></div>
      </div>

      <div className={styles.content}>
        <p className={styles.description}>
          Ваше присутствие на нашем празднике — уже самый ценный подарок! 
          Но если вы хотите нас поздравить материально, у нас есть небольшая просьба.
        </p>

        <div className={styles.preferenceCard}>
          <h3 className={styles.detailTitle}>Наши предпочтения</h3>
          <p className={styles.detailText}>
            Мы будем искренне рады только денежным подаркам
          </p>
          <div className={styles.preferenceList}>
            <div className={styles.preferenceItem}>
              <span className={styles.checkIcon}>✔️</span>
              <span>Деньги (любая сумма будет с благодарностью принята)</span>
            </div>
            <div className={styles.preferenceItem}>
              <span className={styles.xIcon}>❌</span>
              <span>Постельное бельё, сервизы и другие предметы интерьера</span>
            </div>
            <div className={styles.preferenceItem}>
              <span className={styles.xIcon}>❌</span>
              <span>Крупногабаритные подарки</span>
            </div>
            <div className={styles.preferenceItem}>
              <span className={styles.xIcon}>❌</span>
              <span>Цветы</span>
            </div>
          </div>
        </div>

        <p className={styles.note}>
          Ваша поддержка поможет нам в осуществлении наших планов!
        </p>
      </div>
    </div>
  )
}

export default GiftPreference